import React, {useState} from "react";
import {Button, Descriptions, Form, Input} from "antd";

const CL = Form.create({name: 'cl_account_edit'})(({ account, form, save, close }) => {
  const [loading, setLoading] = useState(false);
  const accID = account.meta ? (account.meta.account_id || '') : '';
  const accNumber = account.meta ? (account.meta.account_number || '') : '';
  const customerID = account.meta ? (account.meta.customer_id || '') : '';
  const rut = account.meta ? (account.meta.rut || '') : '';

  const onSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true);
        save(values).then(
          result => close(true),
          error => setLoading(false),
        );
      }
    });
  };

  return (
    <>
      <Descriptions bordered title={account.alias}>
        <Descriptions.Item label="Lana ID" span={3}>
          {account.id}
        </Descriptions.Item>
        <Descriptions.Item label="Lana URL" span={3}>
          <a href={account.url} target="_blank" rel="noopener noreferrer">
              {account.url}
          </a>
        </Descriptions.Item>
        <Descriptions.Item label="Lana REF" span={3}>
          {account.ref}
        </Descriptions.Item>
        <Descriptions.Item label="Account ID" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator("account_id", {
              initialValue: accID ? accID : "",
              rules: [
                {
                  required: true,
                  message: "Account ID is required"
                }
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Account Number" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator("account_number", {
              initialValue: accNumber ? accNumber : "",
              rules: [
                {
                  required: true,
                  message: "Account Number is required"
                }
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="Customer ID" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator("customer_id", {
              initialValue: customerID ? customerID : "",
              rules: [
                {
                  required: true,
                  message: "Customer ID is required"
                }
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label="RUT" span={3}>
          <Form.Item style={{padding: 0, margin: 0}}>
            {form.getFieldDecorator("rut", {
              initialValue: rut ? rut : "",
              rules: [
                {
                  required: true,
                  message: "RUT is required"
                }
              ],
            })(<Input style={{"width": "100%"}} />)}
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
      <div style={{ height: "25px"}}>
        <Form.Item style={{float: 'right'}}>
          <Button style={{marginRight: '5px'}} onClick={() => close(false)}>Cancel</Button>
          <Button loading={loading} type="primary" onClick={onSubmit}>Save</Button>
        </Form.Item>
      </div>
    </>
  )
});

export default CL;
